import { get } from 'lodash'

import { DateFields } from '@sigma-frontend-libs/commons'

import { components, services } from '@/utils'

import filterSendings from '@/components/button/filter/sendings'
import arrow from '@/components/misc/arrow'
import tasksCounts from '@/components/services/sendings/tasks/counts'
import tasksType from '@/components/services/sendings/tasks/type'
import tasksActionsMenu from '@/components/services/tasks/actions/menu'
import tasksActionsUpdate from '@/components/services/tasks/actions/update'
import tasksBatchParams from '@/components/services/tasks/batchParams'
import tasksState from '@/components/services/tasks/state'
import tasksTitle from '@/components/services/tasks/title'
import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderTasksType(h) {
  return h(
    tasksType,
    {
      props: {
        value: this.value
      }
    }
  )
}
function renderTasksState(h) {
  return h(
    tasksState,
    {
      props: {
        value: this.value
      }
    }
  )
}
function renderTasksCounts(h, trigger) {
  if (trigger) {
    return h(
      tasksCounts,
      {
        props: {
          value: this.value
        }
      }
    )
  }
}
function renderTasksTitle(h, trigger) {
  if (this.viewport.size.width >= 1920 || trigger) {
    return h(
      tasksTitle,
      {
        props: {
          value: this.value
        }
      }
    )
  }
}
function renderSender(h) {
  return h(
    sticker,
    {
      props: {
        value: get(this.value, 'data.sending.payload.sender'),
        label: this.getTranslate(`${services.sendings}.labels.sender`),
        copy: true
      }
    }
  )
}
function renderText(h) {
  return h(
    sticker,
    {
      props: {
        value: get(this.value, 'data.sending.payload.text'),
        label: this.getTranslate(`${services.sendings}.labels.text`),
        copy: true,
        tooltipTimeout: 5 * 1000
      }
    }
  )
}
function renderOwner(h, trigger) {
  if (this.viewport.size.width >= 1640 || trigger) {
    return h(
      owner,
      {
        props: {
          value: this.value,
          copy: true
        }
      }
    )
  }
}

function renderFilterSendingsByOwnerButton(h) {
  return h(
    filterSendings,
    {
      props: {
        query: {
          ownerId: this.value?.OwnerId || this.value?.Owner?.id
        }
      }
    }
  )
}
function renderTasksBatchParams(h) {
  return h(
    tasksBatchParams,
    {
      props: {
        value: this.value.data.cycle,
        id: this.value.id,
        type: this.value.type,
        state: this.value.state
      },
      on: {
        menu: event => {
          this.menuIsShowed = event
        }
      }
    }
  )
}
function renderTasksActionsUpdate(h) {
  return h(
    tasksActionsUpdate,
    {
      props: {
        value: this.value
      }
    }
  )
}
function renderTasksActionsMenu(h) {
  return h(
    tasksActionsMenu,
    {
      props: {
        value: this.value
      },
      on: {
        menu: event => {
          this.menuIsShowed = event
        }
      }
    }
  )
}
function renderActions(h, trigger) {
  if (this.viewport.size.width >= 1380 || trigger) {
    return h(
      'div',
      {
        class: `${services.sendings}-tasks__actions hover-child`
      },
      [
        renderFilterSendingsByOwnerButton.call(this, h),
        renderTasksBatchParams.call(this, h),
        renderTasksActionsUpdate.call(this, h),
        renderTasksActionsMenu.call(this, h)
      ]
    )
  }
}
function renderDates(h, trigger) {
  if (this.viewport.size.width >= 1640 || trigger) {
    return h(
      'div',
      {
        class: `${services.sendings}-tasks__dates`
      },
      [ DateFields.createdAt, DateFields.updatedAt ].map(field => {
        return h(
          date,
          {
            props: {
              value: this.value,
              field
            }
          }
        )
      })
    )
  }
}

function renderPanelHeaderInfo(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-tasks-panel__header-info`,
      style: this.$style
    },
    [
      renderTasksType.call(this, h),
      renderTasksState.call(this, h),
      renderTasksCounts.call(this, h, this.viewport.size.width >= 450)
    ]
  )
}
function renderPanelHeader(h, expanded) {
  return h(
    'div',
    {
      class: `${services.sendings}-tasks-panel__header default-expansion-panel-header`
    },
    [
      renderPanelHeaderInfo.call(this, h),
      renderDates.call(this, h),
      h(arrow, { props: { expanded } })
    ]
  )
}
function renderPanelContent(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-tasks-panel__content`
    },
    [
      renderTasksCounts.call(this, h, this.viewport.size.width < 450),
      renderTasksTitle.call(this, h, true),
      renderSender.call(this, h),
      renderText.call(this, h),
      renderOwner.call(this, h, true),
      renderDates.call(this, h, true),
      renderActions.call(this, h, true)
    ]
  )
}

export default function(h) {
  if (this.viewport.breakpoint.lgUp) {
    return h(
      'div',
      {
        class: {
          'service-template-item': true,
          'hover-parent hover-parent--opacity': !this.menuIsShowed,
          [`${services.sendings}-tasks-item`]: true
        },
        key: this.value.id
      },
      [
        renderTasksType.call(this, h),
        renderTasksState.call(this, h),
        renderTasksCounts.call(this, h, true),
        renderTasksTitle.call(this, h),
        renderSender.call(this, h),
        renderText.call(this, h),
        renderOwner.call(this, h),
        renderActions.call(this, h),
        renderDates.call(this, h)
      ]
    )
  } else {
    return h(
      components['expansion-panel'],
      {
        scopedSlots: {
          header: ({ expanded }) => {
            return renderPanelHeader.call(this, h, expanded)
          },
          default: () => {
            return renderPanelContent.call(this, h)
          }
        },
        key: this.value.id
      }
    )
  }
}
